import { useContext } from 'react';
import { InputsContext } from '../../InputsContext'
import { Select } from '@postenbring/hedwig-react';

export const ServiceInput = ({ labels }) => {

    const { setService } = useContext(InputsContext)

    const optionsText = 
        [
            {label: labels.pickUpPointDelivery, value: 'pickUpPointDelivery'},
            {label: labels.homeDeliveryPackage, value: 'homeDeliveryPackage'},
            {label: labels.expressNextDayDelivery, value: 'expressNextDayDelivery'}, 
            {label: labels.businessParcel, value: 'businessParcel'},
            {label: labels.businessGroupage, value: 'businessGroupage'}
        ] 

    return (
        <Select onChange={(event) => setService(event.target.value)} label={labels.selectService}>
            {optionsText.map((option) => (
                <option key={option.value} value={option.value}>
                    {option.label}
                </option>
            ))}
        </Select>
    )
}
